import Vue from 'vue'
import Vuex from 'vuex'
import cookie from 'js-cookie'
import { assign } from 'lodash'

Vue.use(Vuex)

const setAppKelas = (state) => {
  const defaultKelas = [
    'kt-quick-panel--right',
    'kt-demo-panel--right',
    'kt-offcanvas-panel--right',
    // 'kt-header--fixed',
    'kt-header-mobile--fixed',
    'kt-subheader--enabled',
    'kt-subheader--solid',
    // 'kt-subheader--fixed',
    'kt-aside--enabled',
    // 'kt-aside--fixed',
    'kt-page--loading'
  ]
  const kl = assign([], defaultKelas)
  if (state.asideEnable) kl.push('kt-aside--fixed')
  if (state.asideMinimize) kl.push('kt-aside--minimize')
  if (state.mobileAsideMaximize) kl.push('kt-aside--on')
  if (state.mobileHeader) kl.push('kt-header__topbar--mobile-on')
  state.appKelas = kl
}

const domainHasRoles = (process.env.VUE_APP_DOMAIN_HAS_ROLE || '').split(',')

const getRole = (email) => {
  let role = 'admin'
  if (email.split('@').length !== 2) return getRole
  let domain = email.split('@')[1]
  if(!domainHasRoles.includes(domain)) return role

  if (email.indexOf('-checkin@' + domain) > -1) return 'checkin'
  if (email.indexOf('-registration@' + domain) > -1) return 'reg'
  if (email.indexOf('-cs@' + domain) > -1) return 'cs'
  return role
}

export default new Vuex.Store({
  state: {
    appLoading: false,
    notifications: [],
    userData: null,
    teamData: null,
    eventData: null,
    trxData: null,
    asideEnable: false,
    asideMinimize: false,
    mobileAsideMaximize: false,
    mobileHeader: false,
    sessionExpired: true,
    appKelas: []
  },
  getters: {
    allowEvent (state) {
      if (state.teamData === null) return false
      const features = state.teamData.features.find(item => item.name === 'Event Management') || {}
      return features.enable
    },
    domainId (state) {
      const trxData = state.trxData
      if (trxData === null) return null
      return trxData.id
    },
    slug (state) {
      if (state.teamData === null) return ''
      return state.teamData.slug
    }
  },
  mutations: {
    SET_APP_LOADING (state, val) {
      state.appLoading = val
    },
    ADD_NOTIFICATION (state, val) {
      const id = Math.random()
      let noty = state.notifications
      val.id = id
      noty.push(val)
      setTimeout(() => {
        const idx = noty.findIndex(item => { return item.id === id })
        noty.splice(idx, 1)
      }, 5000)
    },
    DEL_NOTIFICATION (state, id) {
      let noty = state.notifications
      const idx = noty.findIndex(item => { return item.id === id })
      noty.splice(idx, 1)
    },
    SET_AUTH_DATA (state, val) {
      if (val !== null) val.role = getRole(val.email)
      state.userData = val
    },
    SET_TRX_DATA (state, val) {
      state.trxData = val
    },
    SET_TEAM_DATA (state, val) {
      state.teamData = val
    },
    SET_EVENT_DATA (state, val) {
      state.eventData = val
    },
    SET_ASIDE_ENABLE (state, val) {
      state.asideEnable = val
      setAppKelas(state)
    },
    SET_ASIDE (state, val) {
      state.asideMinimize = val
      cookie.set('layout-aside', val)
      setAppKelas(state)
    },
    SET_MOB_MENU (state, val) {
      state.mobileAsideMaximize = val
      setAppKelas(state)
    },
    SET_MOB_HEADER (state, val) {
      state.mobileHeader = val
      setAppKelas(state)
    },
    SET_SESSION_EXP (state, val) {
      state.sessionExpired = val
    },
    SET_APP_KELAS (state, val) {
      state.appKelas = val
    }
  },
  actions: {

  }
})
